module.exports = __webpack_public_path__ + "img/23.b7fea5ce.jpg";